import React from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
// import moment from 'moment'
import { Box, Flex } from 'grid-styled'

import {
  getBrasPagAccessToken,
  postBraspagCard
} from '../../../alelo-logic/services/rechargeService'

import { setNewDataValueWithoutRecharge, lockAuthorizationPayment } from 'alelo-logic/actions'
import { setLoading } from '../../modules/PageLoader/actions'

import ImersiveHeader from '../../elements/ImersiveHeader'
import Icon from 'app/elements/Icon/Icon'
import PaymentForm from '../../modules/PaymentForm'
import { validateCreditCardFlag } from '../../modules/EditPaymentForm/validators'
import { showModal } from '../../modules/ModalRoot/actions'
import { CONFIRM_UPDATE } from '../../../constants/ModalTypes'

import pfConfirmationImage from '../../../static/confirmation.png'
import pjImage from '../../../static/icon-veloe-background.svg'
import pfErrorImage from '../../../static/traffic-signal-error.svg'
import Content from '../../../styles/objects/Content'
import { Notice } from './styles'
import { titleModalError, titleModalSuccess, bodyModalSuccess } from './data.json'

const EditPaymentMethod = props => {
  const getPaymentToken = async values => {
    let paymentToken

    await getBrasPagAccessToken()
      .then(async response => {
        const resp = await postBraspagCard(
          formatCardHolderName(values.fullName),
          values.cardNumber.replace(/\s/g, ''),
          values.validThru,
          values.cvv,
          response.data
        )
        paymentToken = resp.data
      })
      .catch(error => console.error(error))
    return paymentToken
  }

  const checkCreditCardFlag = values => {
    const creditCardFlag = validateCreditCardFlag(values)
    if (creditCardFlag) {
      return creditCardFlag
    }
  }

  const formatCardHolderName = name => {
    return name
      .toUpperCase()
      .replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'A')
      .replace(new RegExp('[ÉÈÊ]', 'gi'), 'E')
      .replace(new RegExp('[ÍÌÎ]', 'gi'), 'I')
      .replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'O')
      .replace(new RegExp('[ÚÙÛ]', 'gi'), 'U')
      .replace(new RegExp('[Ç]', 'gi'), 'C')
  }

  const onSubmit = values => {
    const {
      updatePaymentMethod,
      showSuccessModal,
      showErrorModal,
      showCardErrorModal,
      userData,
      location: { state: { currentPlan } },
      setBlockChangePaymentMethod,
      accountType
    } = props

    return new Promise(async (resolve, reject) => {
      // 1. Se for diferente da selecionada, aplicar alteração para a selecionada
      if (values.paymentMethod === 'CUENTA' && values.agency && values.account) {
        // 2. Aplicar debito em conta
        const data = {
          dados: {
            conta: currentPlan.accountId,
            alias: 'EDICAO FORMA PAGAMENTO',
            tipoPagamento: values.paymentMethod,
            cpf: userData.profile.cpf,
            nome: userData.profile.nome,
            agencia: values.agency,
            numeroContaCorrente: `${values.account}${values.accountDigit}`,
            ativo: 1,
            idBanco: values.bankCode.toString()
          }
        }

        updatePaymentMethod(data)
          .then(async () => {
            await setBlockChangePaymentMethod()
            showSuccessModal(accountType)
            resolve()
            props.history.goBack()
          })
          .catch(e => {
            console.error(e) // eslint-disable-line
            showErrorModal()
            reject(e)
          })
      } else if (values.paymentMethod === 'DISPOSICION') {
        const data = {
          dados: {
            conta: currentPlan.accountId,
            alias: 'EDICAO FORMA PAGAMENTO',
            tipoPagamento: values.paymentMethod,
            cpf: userData.profile.cpf,
            nome: userData.profile.nome
          }
        }

        updatePaymentMethod(data)
          .then(async () => {
            await setBlockChangePaymentMethod()
            showSuccessModal(accountType)
            resolve()
            props.history.goBack()
          })
          .catch(e => {
            console.error(e) // eslint-disable-line
            props.showErrorModal()
            reject(e)
          })
      } else if (values.paymentMethod === 'CAJA' && values.cardNumber) {
        const paymentToken = await getPaymentToken(values)
        if (!paymentToken) {
          showCardErrorModal()
          return reject(new Error('Payment Token error'))
        }
        const data = {
          dados: {
            conta: currentPlan.accountId,
            numeroMascarado: (
              values.cardNumber
                .replace(/[^\dA-Z]/g, '')
                .replace(/(.{4})/g, '$1 ')
                .trim()
                .substring(0, 7) +
              'XX-XXXX-' +
              values.cardNumber
                .replace(/[^\dA-Z]/g, '')
                .replace(/(.{4})/g, '$1 ')
                .trim()
                .substring(15)
            ).replace(/\s/g, '-'),
            validade: values.validThru.replace('/20', '-'),
            bandeira: checkCreditCardFlag(values.cardNumber.replace(/\s/g, '')),
            tipoPagamento: values.paymentMethod,
            alias: 'EDICAO FORMA PAGAMENTO',
            nome: formatCardHolderName(values.fullName),
            paymentToken: paymentToken.PaymentToken,
            cvv:
              checkCreditCardFlag(values.cardNumber.replace(/\s/g, '')) === 'amex'
                ? values.cvv
                : values.cvv.slice(0, 3)
          }
        }

        updatePaymentMethod(data)
          .then(async () => {
            await setBlockChangePaymentMethod()
            showSuccessModal(accountType)
            resolve()
            props.history.goBack()
          })
          .catch(e => {
            console.error(e) // eslint-disable-line
            showErrorModal()
            reject(e)
          })
      } else {
        resolve()
      }
    })
  }

  // Removido por ora até ser confirmado que não haverá mais restrição de alteração
  // const ableToChangePaymentForm =
  //   props.authorizations.FORMA &&
  //   !props.authorizations.FORMA.dataProximaAlteracao &&
  //   !props.authorizations.FORMA.error
  // const daysToChangePaymentForm = !ableToChangePaymentForm
  //   ? moment(props.authorizations.FORMA.dataProximaAlteracao, 'DD/MM/YYYY').diff(moment(), 'days') +
  //     1
  //   : 0

  const isCredit =
    props.location.state.currentPlan &&
    props.location.state.currentPlan.paymentType === 'CARTAO_DE_CREDITO'

  const finalCardNumber =
    isCredit && props.creditPaymentInfo.numeroMascarado
      ? props.creditPaymentInfo.numeroMascarado.split('-')[3]
      : null

  return (
    <Flex direction="column">
      <Helmet title="Editar forma de pagamento" />
      <Box>
        <ImersiveHeader text="Dados do plano" back={() => props.history.goBack()} />
      </Box>
      <Content>
        <Box width={[1, 400]} mt={24}>
          <Notice>
            <Icon height={14} icon="alert" viewBox="0 0 16 13" display="flex" />
            {/* {ableToChangePaymentForm ? ( */}
            {isCredit && finalCardNumber ? (
              <span>
                Ao alterar a forma de pagamento, o cartão final <b>{finalCardNumber}</b> será
                automaticamente descadastrado.
              </span>
            ) : (
              <span>
                A forma de pagamento atual será automaticamente descadastrada assim que você
                cadastrar uma nova opção de pagamento.
              </span>
              // Removido por ora até ser confirmado que não haverá mais restrição de alteração
              // )
              // )
              // : (
              //   <span>
              //     Você fez uma alteração de forma de pagamento recentemente.<br /> Em{' '}
              //     <b>{daysToChangePaymentForm}</b> dia{daysToChangePaymentForm > 1 ? 's' : ''} você
              //     poderá fazer uma nova alteração.
              //   </span>
            )}
          </Notice>
        </Box>
        <Box width={[1, 680]}>
          <PaymentForm
            // ableToChangePaymentForm={ableToChangePaymentForm}
            paymentType={props.location.state.currentPlan.paymentType}
            onSubmit={onSubmit}
            dueDates={props.location.state.dueDates}
            paymentTypesOptions={props.location.state.paymentTypes}
            handleBackClick={() => props.history.goBack()}
          />
        </Box>
      </Content>
    </Flex>
  )
}

const mapStateToProps = ({ reducer }) => ({
  userData: reducer.user,
  accountType: reducer.account.accountType,
  authorizations: reducer.planData.authorizations,
  creditPaymentInfo: reducer.recharge.paymentInfo
})

const mapDispatchToProps = dispatch => ({
  showSuccessModal: accountType =>
    dispatch(
      showModal(CONFIRM_UPDATE, {
        modalTitle: titleModalSuccess,
        modalDescription: bodyModalSuccess,
        accountType,
        image: accountType === 'pf' ? pfConfirmationImage : pjImage
      })
    ),
  showErrorModal: accountType =>
    dispatch(
      showModal(CONFIRM_UPDATE, {
        modalTitle: titleModalError,
        modalDescription: (
          <span>
            Não foi possível alterar sua forma de pagamento. <br /> Verifique os dados fornecidos e
            tente novamente
          </span>
        ),
        accountType,
        image: accountType === 'pf' ? pfErrorImage : pjImage
      })
    ),
  showCardErrorModal: accountType =>
    dispatch(
      showModal(CONFIRM_UPDATE, {
        modalTitle: titleModalError,
        modalDescription: (
          <span>
            <b>Cartão inválido</b>
            <br />
            Por favor, confira o número digitado ou escolha outro cartão
          </span>
        ),
        accountType,
        image: accountType === 'pf' ? pfErrorImage : pjImage
      })
    ),
  setBlockChangePaymentMethod: () => dispatch(lockAuthorizationPayment('FORMA')),
  updatePaymentMethod: data => dispatch(setNewDataValueWithoutRecharge(data)),
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(EditPaymentMethod)



// WEBPACK FOOTER //
// ./src/app/pages/EditPaymentMethod/index.js